import AudienceAutoUpdateView from './AudienceAutoUpdate.View';

const AudienceAutoUpdate = () => <AudienceAutoUpdateView />;

export default AudienceAutoUpdate;
